// import {
// 	createContext,
// 	useContext,
// 	useState,
// 	useEffect,
// 	useCallback,
// } from "react";
// import { useAuthContext } from "./AuthContext";
// import { useCartContext } from "./CartContext";
// import { useProfileContext } from "./ProfileContext";
// import axios from "axios";
// import Cookies from "js-cookie";
// import { baseUrl } from "../utils/OtherUtils";
// import { useNavigate } from "react-router-dom";

// const OrderContext = createContext();

// const OrderProvider = ({ children }) => {
// 	const { handleNotification, userLocation } = useAuthContext();
// 	const navigate = useNavigate();
// 	const { userProfile } = useProfileContext();
// 	const { getCart, cartData, clearCart, finalAmount } = useCartContext();
// 	const [isAddMemberPopup, setIsAddMemberPopup] = useState(false);
// 	const [isAddAddressPopup, setIsAddAddressPopup] = useState(false);
// 	const [isPromoCode, setIsPromoCode] = useState(false);
// 	const [promoCode, setPromoCode] = useState("");
// 	const [orderData, setOrderData] = useState([]);
// 	const [orderSummary, setOrderSummary] = useState({});
// 	const [serviceableAreaMessage, setServiceAbleAreaMessage] = useState({
// 		flag: null,
// 		message: "",
// 	});
// 	const [order, setOrder] = useState({
// 		orderId: "",
// 		userDetails: { name: "", contact: "", email: "" },
// 		orderData: [{ patient: [], items: [] }],
// 		address: [],
// 		paymentDetails: {
// 			currency: "",
// 			totalPrice: "",
// 			totalDiscountPrice: "",
// 			finalAmount: "",
// 			collectionCharges: "",
// 			freeChargeDifference: "",
// 			discount: "",
// 			platformFee: "",
// 			freeTestsTotalMRP:"",
// 			totalCartValue: "",
// 		},
// 		collectionDate: { date: {}, time: "" },
// 		geoLocation: { longitude: "", latitude: "" },
// 		status: "Pending",
// 		appliedPromoCode: "",
// 	});
// 	const [currency, setCurrency] = useState("INR");
// 	const [receipt, setReceipt] = useState("receipt_#0");
// 	const [isPaymentDone, setIsPaymentDone] = useState(false);
// 	const [orderId, setOrderId] = useState("");
// 	const [promoCodeMessage, setPromoCodeMessage] = useState({
// 		flag: null,
// 		message: "",
// 	});
// 	const [indexToAddMember, setIndexToAddMember] = useState(null);

// 	// Function to save a member into the patient's array
// 	const saveMember = (member) => {
// 		setOrder((prevOrder) => ({
// 			...prevOrder,
// 			orderData: prevOrder.orderData.map((data, index) =>
// 				index === indexToAddMember
// 					? { ...data, patient: [...data.patient, member] } // Update the patient array in the first element
// 					: data
// 			),
// 		}));

// 		setIsAddMemberPopup(false);
// 	};

// 	// Function to save an address into the address array
// 	const saveAddress = (address) => {
// 		setOrder((prevOrder) => {
// 			const updatedOrder = {
// 				...prevOrder,
// 				address: [...prevOrder.address, address], // Add the new address to the array
// 			};

// 			// Trigger serviceable area check after updating the order
// 			handleServiceableArea(updatedOrder);

// 			return updatedOrder;
// 		});

// 		setIsAddAddressPopup(false); // Close the address popup
// 	};

// 	// Function to remove address
// 	const removeAddress = () => {
// 		setOrder((prevOrder) => ({
// 			...prevOrder,
// 			address: [], // Reset the address array to an empty array
// 			collectionDate: { date: {}, time: "" }, // Clear collection date and time
// 			visitDate: { date: {}, time: "" }, // Clear visit date and time
// 			visitCenter: "", // Clear visit center
// 			collectionType: "", // Reset collection type (add to your order state if you store it here)
// 		}));
// 	};

// 	// Function to save the collection date
// 	const saveDate = (date) => {
// 		setOrder((prevOrder) => ({
// 			...prevOrder,
// 			collectionDate: { ...prevOrder.collectionDate, date },
// 		}));
// 	};

// 	// Function to save the collection time
// 	const saveTime = (time) => {
// 		setOrder((prevOrder) => ({
// 			...prevOrder,
// 			collectionDate: { ...prevOrder.collectionDate, time },
// 		}));
// 	};

// 	const removePatient = (orderDataIndex, patientIndex) => {
// 		setOrder((prevOrder) => ({
// 			...prevOrder,
// 			orderData: prevOrder.orderData.map((data, currentOrderDataIndex) =>
// 				currentOrderDataIndex === orderDataIndex // Match the index in orderData
// 					? {
// 							...data,
// 							patient: data.patient.filter(
// 								(_, currentPatientIndex) => currentPatientIndex !== patientIndex
// 							), // Remove the patient at the given index
// 					  }
// 					: data
// 			),
// 		}));
// 	};

// 	const removeItemByProductCode = (productCode) => {
// 		setOrder((prevOrder) => ({
// 			...prevOrder,
// 			items: prevOrder.items.filter((item) => item.productCode !== productCode),
// 		}));
// 	};

// 	const removeProductItems = (index, idx) => {
// 		setOrder((prevOrder) => ({
// 			...prevOrder,
// 			orderData: prevOrder.orderData.map((data, orderDataIdx) =>
// 				orderDataIdx === index // Match the index in orderData
// 					? {
// 							...data,
// 							items: data.items.filter((_, itemIdx) => itemIdx !== idx), // Remove the item at the given idx
// 					  }
// 					: data
// 			),
// 		}));
// 	};

// 	// Populate `paymentDetails` dynamically
// 	useEffect(() => {
// 		// Only update if `orderSummary` has valid data
// 		if (orderSummary?.success) {
// 			setOrder((prevOrder) => ({
// 				...prevOrder,
// 				paymentDetails: {
// 					currency: orderSummary.currency,
// 					totalPrice: orderSummary.totalPrice,
// 					totalDiscountPrice: orderSummary.totalDiscountPrice,
// 					finalAmount: orderSummary.finalAmount,
// 					totalCartValue: orderSummary.totalCartValue,
// 					freeTestsTotalMRP:orderSummary.freeTestsTotalMRP,
// 					collectionCharges: orderSummary.collectionCharges,
// 					freeChargeDifference: orderSummary.freeChargeDifference,
// 					discount: orderSummary.discount,
// 					platformFee: orderSummary.platformFee,
// 				},
// 			}));
// 		}
// 	}, [orderSummary]); // Dependency ensures this runs whenever `orderSummary` changes

// 	// Populate `geoLocation` dynamically
// 	useEffect(() => {
// 		if (userLocation) {
// 			setOrder((prevOrder) => ({
// 				...prevOrder,
// 				geoLocation: {
// 					longitude: userLocation.longitude || "",
// 					latitude: userLocation.latitude || "",
// 				},
// 			}));
// 		}
// 	}, [userLocation]);

// 	// Populate `userDetails` dynamically
// 	useEffect(() => {
// 		if (userProfile) {
// 			setOrder((prevOrder) => ({
// 				...prevOrder,
// 				userDetails: {
// 					name: userProfile.name || "",
// 					contact: userProfile.contact || "",
// 					email: userProfile.email || "",
// 				},
// 			}));
// 		}
// 	}, [userProfile]);

// 	// Populate items inside orderData
// 	{
// 		/** useEffect(() => {
//     if (cartData?.items) {
//       setOrder((prevOrder) => ({
//         ...prevOrder,
//         orderData: prevOrder.orderData.map((data) => ({
//           ...data,
//           items: cartData.items, // Update the items array for all elements in orderData
//         })),
//       }));
//     }
//   }, [cartData.items]); */
// 	}

// 	useEffect(() => {
// 		if (cartData?.items) {
// 			setOrder((prevOrder) => ({
// 				...prevOrder,
// 				orderData: prevOrder.orderData.map((data) => {
// 					const newItems = cartData.items.filter(
// 						(newItem) =>
// 							!data.items.some((existingItem) => existingItem.id === newItem.id)
// 					); // Find items in cartData.items that are not in data.items
// 					return {
// 						...data,
// 						items: [...data.items, ...newItems], // Add only the new items
// 					};
// 				}),
// 			}));
// 		}
// 	}, [cartData?.items]);

// 	// Populate promocode
// 	useEffect(() => {
// 		setOrder((prevOrder) => ({
// 			...prevOrder,
// 			appliedPromoCode: cartData.appliedPromoCode,
// 		}));
// 	}, [cartData?.appliedPromoCode]);

// 	// Remove orderData if items empty
// 	useEffect(() => {
// 		if (cartData?.items) {
// 			setOrder((prevOrder) => ({
// 				...prevOrder,
// 				orderData: prevOrder.orderData.map((data) => ({
// 					...data,
// 					items: data.items.length === 0 ? cartData.items : data.items, // Only update if items are empty
// 				})),
// 			}));
// 		}
// 	}, [cartData?.items]);

// 	// Handle add another member
// 	const handleAddAnotherMember = () => {
// 		if (order.orderData.length < 3) {
// 			setOrder((prevOrder) => ({
// 				...prevOrder,
// 				orderData: [
// 					...prevOrder.orderData,
// 					{ patient: [], items: cartData?.items || [] }, // Add a new object to the orderData array
// 				],
// 			}));
// 		} else {
// 			handleNotification(
// 				false,
// 				"Cannot add more members. Maximum limit reached."
// 			);
// 		}
// 	};

// 	// Handle remove member
// 	const handleRemoveMember = () => {
// 		setOrder((prevOrder) => ({
// 			...prevOrder,
// 			orderData: prevOrder.orderData.filter((data) => data.items.length > 0),
// 		}));
// 	};

// 	// useEffect to detect and remove empty items
// 	useEffect(() => {
// 		const hasEmptyItems = order.orderData.some(
// 			(data) => data.items.length === 0
// 		);
// 		if (hasEmptyItems) {
// 			handleRemoveMember();
// 		}
// 	}, [order]);

// 	// Function to create order
// 	const handleCreateOrder = useCallback(async () => {
// 		try {
// 			console.log(" orderContext file and line 300 handleCreateOrder");
// 			const url = `${baseUrl}/api/create-order`;
// 			const data = {
// 				amount: Math.round(parseFloat(orderSummary?.finalAmount) * 100),
// 				currency,
// 				receipt,
// 			};

// 			const response = await axios.post(url, data, {
// 				headers: {
// 					"Content-Type": "application/json",
// 				},
// 			});

// 			if (response?.data?.success) {
// 				const createOrderDataResponse = response?.data?.createOrderData;

// 				// Open Razorpay payment window
// 				const options = {
// 					// key: "rzp_live_mlO20lt64Wtvpj",
// 					key: "rzp_test_bndj2YHgGFUarQ",
// 					amount: createOrderDataResponse?.amount,
// 					currency: createOrderDataResponse?.currency,
// 					name: "Fine Labs",
// 					description: "Order Payment",
// 					image: "/assets/finelabs-logo-rp.png",
// 					order_id: createOrderDataResponse?.id, // Razorpay order ID
// 					handler: function (paymentResponse) {
// 						// Handle successful payment
// 						setIsPaymentDone(true);
// 					},
// 					prefill: {
// 						name: userProfile?.name || "",
// 						email: userProfile?.email || "",
// 						contact: userProfile?.contact || "",
// 					},
// 					notes: {
// 						address: "",
// 					},
// 					theme: {
// 						color: "#F37254",
// 					},
// 				};

// 				const razorpay = new window.Razorpay(options);

// 				razorpay.on("payment.failed", function (response) {
// 					console.error("Payment failed:", response.error);
// 					// Handle payment failure
// 				});

// 				razorpay.open();
// 			} else {
// 				console.log("Order creation failed:", response?.data);
// 			}
// 		} catch (err) {
// 			console.error(
// 				"Failed to create order:",
// 				err.response?.data || "Something went wrong"
// 			);
// 		}
// 	}, [baseUrl, finalAmount, currency, receipt, orderSummary?.finalAmount]);

// 	// Function to create order
// 	const createOrder = useCallback(async () => {
// 		console.log("orderContext file and line 365 createORder")
// 		const url = `${baseUrl}/api/orders/create-order`;
// 		const token = Cookies.get("token");
// 		const userId = Cookies.get("userId");

// 		// Check for missing authentication details
// 		if (!token || !userId) {
// 			console.error("Missing authentication details.");
// 			return { success: false, message: "Authentication required." };
// 		}

// 		try {
// 			const headers = {
// 				Authorization: `Bearer ${token}`,
// 				"Content-Type": "application/json",
// 			};

// 			// Send POST request to create order
// 			const response = await axios.post(url, { ...order, userId }, { headers });

// 			if (response.data.success) {
// 				clearCart();
// 				fetchOrders();
// 				navigate("/payment/thank-you");
// 				return response.data;
// 			} else {
// 				console.error("Failed to create order:", response.data.message);
// 				return response.data;
// 			}
// 		} catch (error) {
// 			console.error("Error creating order:", error.message);

// 			return { success: false, message: error.message };
// 		}
// 	}, [order]);

// 	// Function to get orders
// 	const fetchOrders = useCallback(async () => {
// 		const token = Cookies.get("token");
// 		const userId = Cookies.get("userId");

// 		if (!token || !userId) {
// 			console.error("Authentication required. Missing token or userId.");
// 			return;
// 		}

// 		try {
// 			const headers = {
// 				Authorization: `Bearer ${token}`,
// 			};

// 			const response = await axios.get(`${baseUrl}/api/orders/get-order`, {
// 				params: { userId },
// 				headers,
// 			});

// 			if (response.data.success) {
// 				setOrderData(response?.data?.orders);
// 			} else {
// 				console.error(response?.data?.message);
// 				return [];
// 			}
// 		} catch (error) {
// 			console.error("Error fetching orders:", error.message);
// 		}
// 	}, []);

// 	// Function for promo code
// 	const handleApplyPromoCode = useCallback(async () => {
// 		try {
// 			// Get the token and userId from cookies
// 			const token = Cookies.get("token");
// 			const userId = Cookies.get("userId");

// 			// Set the Authorization header with the token
// 			const config = {
// 				headers: {
// 					Authorization: `Bearer ${token}`,
// 				},
// 			};

// 			// Send POST request to apply the promo code
// 			const response = await axios.post(
// 				`${baseUrl}/api/cart/apply-promocode`,
// 				{ promoCode, userId },
// 				config
// 			);

// 			// Update response message based on API response
// 			if (response.data.success) {
// 				getCart();
// 				setPromoCodeMessage({
// 					flag: response?.data?.success,
// 					message: response?.data?.message,
// 				});
// 				setIsPromoCode(false);
// 			} else {
// 				setPromoCodeMessage({
// 					flag: response?.data?.success,
// 					message: response?.data?.message,
// 				});
// 			}
// 		} catch (error) {
// 			console.error("Error applying promo code:", error);
// 			setPromoCodeMessage({
// 				flag: error?.response?.data?.success,
// 				message: error?.response?.data?.message,
// 			});
// 		}
// 	}, [baseUrl, promoCode]);

// 	// Function to check servisable area
// 	const handleServiceableArea = useCallback(
// 		async (updatedOrder = order) => {
// 			const brandName =
// 				updatedOrder?.orderData[0]?.items[0]?.productId?.brandName;
// 			const pincode =
// 				updatedOrder?.address[updatedOrder.address.length - 1]?.pincode;

// 			// Ensure brandName and pincode are available
// 			if (!brandName || !pincode) {
// 				console.error("Brand name or pincode is missing.");
// 				return;
// 			}

// 			try {
// 				const url = `${baseUrl}/api/orders/serviceable-area`;

// 				// Send POST request to check if the area is serviceable
// 				const response = await axios.post(url, { brandName, pincode });

// 				setServiceAbleAreaMessage({
// 					flag: response?.data?.success,
// 					message: response?.data?.message,
// 				});
// 			} catch (error) {
// 				console.error("Error while getting serviceable area:", error);
// 			}
// 		},
// 		[baseUrl, order]
// 	);

// 	// Function to remove promo code
// 	const handleRemovePromoCode = useCallback(async () => {
// 		try {
// 			// Get the token and userId from cookies
// 			const token = Cookies.get("token");
// 			const userId = Cookies.get("userId");

// 			// Ensure userId is available
// 			if (!userId) {
// 				console.error("User ID is missing.");
// 				return;
// 			}

// 			// Set the Authorization header with the token
// 			const config = {
// 				headers: {
// 					Authorization: `Bearer ${token}`,
// 				},
// 			};

// 			// Send POST request to remove the promo code
// 			const response = await axios.post(
// 				`${baseUrl}/api/cart/remove-promocode`,
// 				{ userId },
// 				config
// 			);

// 			// Update response message based on API response
// 			if (response.data.success) {
// 				getCart();
// 				setPromoCodeMessage({
// 					flag: response?.data?.success,
// 					message: response?.data?.message,
// 				});
// 				//setIsPromoCode(true); // Allow applying a new promo code
// 			} else {
// 				setPromoCodeMessage({
// 					flag: response?.data?.success,
// 					message: response?.data?.message,
// 				});
// 			}
// 		} catch (error) {
// 			console.error("Error removing promo code:", error);
// 		}
// 	}, [baseUrl]);

// 	// Calculate total price from user cart
// 	const calculateTotalPrice = useCallback(
// 		async (orderData) => {
// 			try {
// 				// Get the token and userId from cookies
// 				const token = Cookies.get("token");
// 				//const userId = Cookies.get("userId");

// 				// Check if token exists
// 				if (!token) {
// 					throw new Error("User is not authenticated");
// 				}

// 				// Set the Authorization header with the token
// 				const config = {
// 					headers: {
// 						Authorization: `Bearer ${token}`,
// 					},
// 				};

// 				// Send POST request to calculate the total price
// 				const response = await axios.post(
// 					`${baseUrl}/api/cart/calculate-total-price`,
// 					{ orderData },
// 					config
// 				);

// 				// Handle the response (display or use totalPrice)
// 				if (response?.data?.success) {
// 					setOrderSummary(response?.data);
// 				} else {
// 					console.error("Error:", response?.data?.message);
// 				}
// 			} catch (error) {
// 				console.error("Error calculating total price:", error?.message);
// 			}
// 		},
// 		[baseUrl]
// 	);

// 	{
// 		/*   useEffect(() => {
//     calculateTotalPrice(order?.orderData);
//   }, [order?.orderData]); */
// 	}

// 	useEffect(() => {
// 		if (isPaymentDone) {
// 			createOrder();
// 		}
// 	}, [isPaymentDone]);

// 	return (
// 		<OrderContext.Provider
// 			value={{
// 				isAddMemberPopup,
// 				setIsAddMemberPopup,
// 				isAddAddressPopup,
// 				setIsAddAddressPopup,
// 				orderData,
// 				setOrderData,
// 				order,
// 				setOrder,
// 				saveMember,
// 				saveAddress,
// 				removeAddress,
// 				saveDate,
// 				saveTime,
// 				removePatient,
// 				removeItemByProductCode,
// 				createOrder,
// 				fetchOrders,
// 				handleCreateOrder,
// 				handleAddAnotherMember,
// 				removeProductItems,
// 				setIndexToAddMember,
// 				isPromoCode,
// 				setIsPromoCode,
// 				promoCode,
// 				setPromoCode,
// 				handleApplyPromoCode,
// 				handleRemovePromoCode,
// 				serviceableAreaMessage,
// 				orderSummary,
// 				promoCodeMessage,
// 			}}>
// 			{children}
// 		</OrderContext.Provider>
// 	);
// };

// export const useOrderContext = () => useContext(OrderContext);

// export default OrderProvider;




import {
	createContext,
	useContext,
	useState,
	useEffect,
	useCallback,
} from "react";
import { useAuthContext } from "./AuthContext";
import { useCartContext } from "./CartContext";
import { useProfileContext } from "./ProfileContext";
import axios from "axios";
import Cookies from "js-cookie";
import { baseUrl } from "../utils/OtherUtils";
import { useNavigate } from "react-router-dom";

const OrderContext = createContext();

const OrderProvider = ({ children }) => {
	const { handleNotification, userLocation } = useAuthContext();
	const navigate = useNavigate();
	const { userProfile } = useProfileContext();
	const { getCart, cartData, clearCart, finalAmount } = useCartContext();
	const [isAddMemberPopup, setIsAddMemberPopup] = useState(false);
	const [isAddAddressPopup, setIsAddAddressPopup] = useState(false);
	const [isPromoCode, setIsPromoCode] = useState(false);
	const [promoCode, setPromoCode] = useState("");
	const [orderData, setOrderData] = useState([]);
	const [orderSummary, setOrderSummary] = useState({});
	const [serviceableAreaMessage, setServiceAbleAreaMessage] = useState({
		flag: null,
		message: "",
	});
	const [order, setOrder] = useState({
		orderId: "",
		userDetails: { name: "", contact: "", email: "" },
		orderData: [{ patient: [], items: [] }],
		address: [],
		matchedFreeTest: {
			brand: "",
			name: "",
			price: "",
		},
		paymentDetails: {
			currency: "",
			totalPrice: "",
			totalDiscountPrice: "",
			finalAmount: "",
			collectionCharges: "",
			freeChargeDifference: "",
			discount: "",
			platformFee: "",
		},
		collectionDate: { date: {}, time: "" },
		geoLocation: { longitude: "", latitude: "" },
		status: "Pending",
		appliedPromoCode: "",
	});
	const [currency, setCurrency] = useState("INR");
	const [receipt, setReceipt] = useState("receipt_#0");
	const [isPaymentDone, setIsPaymentDone] = useState(false);
	const [orderId, setOrderId] = useState("");
	const [promoCodeMessage, setPromoCodeMessage] = useState({
		flag: null,
		message: "",
	});
	const [indexToAddMember, setIndexToAddMember] = useState(null);

	// Function to save a member into the patient's array
	const saveMember = (member) => {
		setOrder((prevOrder) => ({
			...prevOrder,
			orderData: prevOrder.orderData.map((data, index) =>
				index === indexToAddMember
					? { ...data, patient: [...data.patient, member] } // Update the patient array in the first element
					: data
			),
		}));

		setIsAddMemberPopup(false);
	};

	// Function to save an address into the address array
	const saveAddress = (address) => {
		setOrder((prevOrder) => {
			const updatedOrder = {
				...prevOrder,
				address: [...prevOrder.address, address], // Add the new address to the array
			};

			// Trigger serviceable area check after updating the order
			handleServiceableArea(updatedOrder);

			return updatedOrder;
		});

		setIsAddAddressPopup(false); // Close the address popup
	};

	// Function to remove address
	const removeAddress = () => {
		setOrder((prevOrder) => ({
			...prevOrder,
			address: [], // Reset the address array to an empty array
			collectionDate: { date: {}, time: "" }, // Clear collection date and time
			visitDate: { date: {}, time: "" }, // Clear visit date and time
			visitCenter: "", // Clear visit center
			collectionType: "", // Reset collection type (add to your order state if you store it here)
		}));
	};

	// Function to save the collection date
	const saveDate = (date) => {
		setOrder((prevOrder) => ({
			...prevOrder,
			collectionDate: { ...prevOrder.collectionDate, date },
		}));
	};

	// Function to save the collection time
	const saveTime = (time) => {
		setOrder((prevOrder) => ({
			...prevOrder,
			collectionDate: { ...prevOrder.collectionDate, time },
		}));
	};

	const removePatient = (orderDataIndex, patientIndex) => {
		setOrder((prevOrder) => ({
			...prevOrder,
			orderData: prevOrder.orderData.map((data, currentOrderDataIndex) =>
				currentOrderDataIndex === orderDataIndex // Match the index in orderData
					? {
						...data,
						patient: data.patient.filter(
							(_, currentPatientIndex) => currentPatientIndex !== patientIndex
						), // Remove the patient at the given index
					}
					: data
			),
		}));
	};

	const removeItemByProductCode = (productCode) => {
		setOrder((prevOrder) => ({
			...prevOrder,
			items: prevOrder.items.filter((item) => item.productCode !== productCode),
		}));
	};

	const removeProductItems = (index, idx) => {
		setOrder((prevOrder) => ({
			...prevOrder,
			orderData: prevOrder.orderData.map((data, orderDataIdx) =>
				orderDataIdx === index // Match the index in orderData
					? {
						...data,
						items: data.items.filter((_, itemIdx) => itemIdx !== idx), // Remove the item at the given idx
					}
					: data
			),
		}));
	};

	// Populate `paymentDetails` dynamically
	useEffect(() => {
		// Only update if `orderSummary` has valid data
		if (orderSummary?.success) {
			setOrder((prevOrder) => ({
				...prevOrder,
				matchedFreeTest: orderSummary.matchedFreeTest,
				freeTest: orderSummary.freeTest,
				paymentDetails: {
					currency: orderSummary.currency,
					totalPrice: orderSummary.totalPrice,
					totalDiscountPrice: orderSummary.totalDiscountPrice,
					finalAmount: orderSummary.finalAmount,
					collectionCharges: orderSummary.collectionCharges,
					matchedFreeTest: orderSummary.matchedFreeTest,
					freeTest: orderSummary.freeTest,
					freeChargeDifference: orderSummary.freeChargeDifference,
					discount: orderSummary.discount,
					platformFee: orderSummary.platformFee,
				},
			}));
		}
	}, [orderSummary]); // Dependency ensures this runs whenever `orderSummary` changes

	// Populate `geoLocation` dynamically
	useEffect(() => {
		if (userLocation) {
			setOrder((prevOrder) => ({
				...prevOrder,
				geoLocation: {
					longitude: userLocation.longitude || "",
					latitude: userLocation.latitude || "",
				},
			}));
		}
	}, [userLocation]);

	// Populate `userDetails` dynamically
	useEffect(() => {
		if (userProfile) {
			setOrder((prevOrder) => ({
				...prevOrder,
				userDetails: {
					name: userProfile.name || "",
					contact: userProfile.contact || "",
					email: userProfile.email || "",
				},
			}));
		}
	}, [userProfile]);

	// Populate items inside orderData
	{
		/** useEffect(() => {
	if (cartData?.items) {
	  setOrder((prevOrder) => ({
		...prevOrder,
		orderData: prevOrder.orderData.map((data) => ({
		  ...data,
		  items: cartData.items, // Update the items array for all elements in orderData
		})),
	  }));
	}
  }, [cartData.items]); */
	}

	useEffect(() => {
		if (cartData?.items) {
			setOrder((prevOrder) => ({
				...prevOrder,
				orderData: prevOrder.orderData.map((data) => {
					const newItems = cartData.items.filter(
						(newItem) =>
							!data.items.some((existingItem) => existingItem.id === newItem.id)
					); // Find items in cartData.items that are not in data.items
					return {
						...data,
						items: [...data.items, ...newItems], // Add only the new items
					};
				}),
			}));
		}
	}, [cartData?.items]);

	// Populate promocode
	useEffect(() => {
		setOrder((prevOrder) => ({
			...prevOrder,
			appliedPromoCode: cartData.appliedPromoCode,
		}));
	}, [cartData?.appliedPromoCode]);

	// Remove orderData if items empty
	useEffect(() => {
		if (cartData?.items) {
			setOrder((prevOrder) => ({
				...prevOrder,
				orderData: prevOrder.orderData.map((data) => ({
					...data,
					items: data.items.length === 0 ? cartData.items : data.items, // Only update if items are empty
				})),
			}));
		}
	}, [cartData?.items]);

	// Handle add another member
	const handleAddAnotherMember = () => {
		if (order.orderData.length < 3) {
			setOrder((prevOrder) => ({
				...prevOrder,
				orderData: [
					...prevOrder.orderData,
					{ patient: [], items: cartData?.items || [] }, // Add a new object to the orderData array
				],
			}));
		} else {
			handleNotification(
				false,
				"Cannot add more members. Maximum limit reached."
			);
		}
	};

	// Handle remove member
	const handleRemoveMember = () => {
		setOrder((prevOrder) => ({
			...prevOrder,
			orderData: prevOrder.orderData.filter((data) => data.items.length > 0),
		}));
	};

	// useEffect to detect and remove empty items
	useEffect(() => {
		const hasEmptyItems = order.orderData.some(
			(data) => data.items.length === 0
		);
		if (hasEmptyItems) {
			handleRemoveMember();
		}
	}, [order]);

	// Function to create order
	const handleCreateOrder = useCallback(async () => {
		try {
			console.log(" orderContext file and line 300 handleCreateOrder");
			const url = `${baseUrl}/api/create-order`;
			const data = {
				amount: Math.round(parseFloat(orderSummary?.finalAmount) * 100),
				currency,
				receipt,
			};

			const response = await axios.post(url, data, {
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (response?.data?.success) {
				const createOrderDataResponse = response?.data?.createOrderData;

				// Open Razorpay payment window
				const options = {
					key: "rzp_live_mlO20lt64Wtvpj",
					// key: "rzp_test_bndj2YHgGFUarQ",
					amount: createOrderDataResponse?.amount,
					currency: createOrderDataResponse?.currency,
					name: "Fine Labs",
					description: "Order Payment",
					image: "/assets/finelabs-logo-rp.png",
					order_id: createOrderDataResponse?.id, // Razorpay order ID
					handler: function (paymentResponse) {
						// Handle successful payment
						setIsPaymentDone(true);
					},
					prefill: {
						name: userProfile?.name || "",
						email: userProfile?.email || "",
						contact: userProfile?.contact || "",
					},
					notes: {
						address: "",
					},
					theme: {
						color: "#F37254",
					},
				};

				const razorpay = new window.Razorpay(options);

				razorpay.on("payment.failed", function (response) {
					console.error("Payment failed:", response.error);
					// Handle payment failure
				});

				razorpay.open();
			} else {
				console.log("Order creation failed:", response?.data);
			}
		} catch (err) {
			console.error(
				"Failed to create order:",
				err.response?.data || "Something went wrong"
			);
		}
	}, [baseUrl, finalAmount, currency, receipt, orderSummary?.finalAmount]);

	// Function to create order
	const createOrder = useCallback(async () => {
		console.log("orderContext file and line 365 createORder")
		const url = `${baseUrl}/api/orders/create-order`;
		const token = Cookies.get("token");
		const userId = Cookies.get("userId");

		// Check for missing authentication details
		if (!token || !userId) {
			console.error("Missing authentication details.");
			return { success: false, message: "Authentication required." };
		}

		try {
			const headers = {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			};

			// Send POST request to create order
			const response = await axios.post(url, { ...order, userId }, { headers });

			if (response.data.success) {
				clearCart();
				fetchOrders();
				navigate("/payment/thank-you");
				return response.data;
			} else {
				console.error("Failed to create order:", response.data.message);
				return response.data;
			}
		} catch (error) {
			console.error("Error creating order:", error.message);

			return { success: false, message: error.message };
		}
	}, [order]);

	// Function to get orders
	const fetchOrders = useCallback(async () => {
		const token = Cookies.get("token");
		const userId = Cookies.get("userId");

		if (!token || !userId) {
			console.error("Authentication required. Missing token or userId.");
			return;
		}

		try {
			const headers = {
				Authorization: `Bearer ${token}`,
			};

			const response = await axios.get(`${baseUrl}/api/orders/get-order`, {
				params: { userId },
				headers,
			});

			if (response.data.success) {
				setOrderData(response?.data?.orders);
			} else {
				console.error(response?.data?.message);
				return [];
			}
		} catch (error) {
			console.error("Error fetching orders:", error.message);
		}
	}, []);

	// Function for promo code
	const handleApplyPromoCode = useCallback(async () => {
		try {
			// Get the token and userId from cookies
			const token = Cookies.get("token");
			const userId = Cookies.get("userId");
			// console.log("Api token called")
			// Set the Authorization header with the token
			const config = {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			};

			// Send POST request to apply the promo code
			const response = await axios.post(
				`${baseUrl}/api/cart/apply-promocode`,
				{ promoCode, userId },
				config
			);
			// console.log("Api called")
			// console.log("Matched Free Test from API:", response.data.matchedFreeTest);

			// Update response message based on API response
			if (response.data.success) {
				getCart();
				setPromoCodeMessage({
					flag: response?.data?.success,
					message: response?.data?.message,
				});
				// console.log("Matched Free Test from API:", response.data.matchedFreeTest);
				setIsPromoCode(false);
			} else {
				setPromoCodeMessage({
					flag: response?.data?.success,
					message: response?.data?.message,
				});
			}
		} catch (error) {
			console.error("Error applying promo code:", error);
			setPromoCodeMessage({
				flag: error?.response?.data?.success,
				message: error?.response?.data?.message,
			});
		}
	}, [baseUrl, promoCode]);

	// Function to check servisable area
	const handleServiceableArea = useCallback(
		async (updatedOrder = order) => {
			const brandName =
				updatedOrder?.orderData[0]?.items[0]?.productId?.brandName;
			const pincode =
				updatedOrder?.address[updatedOrder.address.length - 1]?.pincode;

			// Ensure brandName and pincode are available
			if (!brandName || !pincode) {
				console.error("Brand name or pincode is missing.");
				return;
			}

			try {
				const url = `${baseUrl}/api/orders/serviceable-area`;

				// Send POST request to check if the area is serviceable
				const response = await axios.post(url, { brandName, pincode });

				setServiceAbleAreaMessage({
					flag: response?.data?.success,
					message: response?.data?.message,
				});
			} catch (error) {
				console.error("Error while getting serviceable area:", error);
			}
		},
		[baseUrl, order]
	);

	// Function to remove promo code
	const handleRemovePromoCode = useCallback(async () => {
		try {
			// Get the token and userId from cookies
			const token = Cookies.get("token");
			const userId = Cookies.get("userId");

			// Ensure userId is available
			if (!userId) {
				console.error("User ID is missing.");
				return;
			}

			// Set the Authorization header with the token
			const config = {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			};

			// Send POST request to remove the promo code
			const response = await axios.post(
				`${baseUrl}/api/cart/remove-promocode`,
				{ userId },
				config
			);

			// Update response message based on API response
			if (response.data.success) {
				getCart();
				setPromoCodeMessage({
					flag: response?.data?.success,
					message: response?.data?.message,
				});
				//setIsPromoCode(true); // Allow applying a new promo code
			} else {
				setPromoCodeMessage({
					flag: response?.data?.success,
					message: response?.data?.message,
				});
			}
		} catch (error) {
			console.error("Error removing promo code:", error);
		}
	}, [baseUrl]);

	// Calculate total price from user cart
	const calculateTotalPrice = useCallback(
		async (orderData) => {
			try {
				// Get the token and userId from cookies
				const token = Cookies.get("token");
				//const userId = Cookies.get("userId");

				// Check if token exists
				if (!token) {
					throw new Error("User is not authenticated");
				}

				// Set the Authorization header with the token
				const config = {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				};

				// Send POST request to calculate the total price
				const response = await axios.post(
					`${baseUrl}/api/cart/calculate-total-price`,
					{ orderData },
					config
				);

				// Handle the response (display or use totalPrice)
				if (response?.data?.success) {
					setOrderSummary(response?.data);
				} else {
					console.error("Error:", response?.data?.message);
				}
			} catch (error) {
				console.error("Error calculating total price:", error?.message);
			}
		},
		[baseUrl]
	);

	{
		/*   useEffect(() => {
	calculateTotalPrice(order?.orderData);
  }, [order?.orderData]); */
	}

	useEffect(() => {
		if (isPaymentDone) {
			createOrder();
		}
	}, [isPaymentDone]);

	return (
		<OrderContext.Provider
			value={{
				isAddMemberPopup,
				setIsAddMemberPopup,
				isAddAddressPopup,
				setIsAddAddressPopup,
				orderData,
				setOrderData,
				order,
				setOrder,
				saveMember,
				saveAddress,
				removeAddress,
				saveDate,
				saveTime,
				removePatient,
				removeItemByProductCode,
				createOrder,
				fetchOrders,
				handleCreateOrder,
				handleAddAnotherMember,
				removeProductItems,
				setIndexToAddMember,
				isPromoCode,
				setIsPromoCode,
				promoCode,
				setPromoCode,
				handleApplyPromoCode,
				handleRemovePromoCode,
				serviceableAreaMessage,
				orderSummary,
				promoCodeMessage,
			}}>
			{children}
		</OrderContext.Provider>
	);
};

export const useOrderContext = () => useContext(OrderContext);

export default OrderProvider;